// extracted by mini-css-extract-plugin
module.exports = {"main":"HtmlBlock_main__9_jF7","load":"HtmlBlock_load__ID1M7"};